import type { CityConfig } from "../city-template/types";

export const kenoshaConfig: CityConfig = {
  city: "Kenosha",
  state: "Wisconsin",
  stateAbbr: "WI",
  slug: "kenosha-wi",
  route: "/cities/kenosha-wi",
  title: "Emergency Passport Kenosha WI | Expedited Passport WI-IL Border | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Kenosha, Wisconsin — as fast as 24 hours. Fast passport renewal and new passport applications for Kenosha, Pleasant Prairie, Somers, and all Kenosha County residents. A+ BBB rated registered courier with access to Chicago Passport Agency — just 60 miles south.",
  h1: "Emergency & Expedited Passport Services in Kenosha, WI",
  heroSubtitle: "Kenosha sits just 60 miles north of the Chicago Passport Agency — one of the closest Wisconsin cities to a U.S. regional passport agency. Fast Passport Center's registered couriers deliver your documents to Chicago so you get a new or renewed passport as fast as 24 hours, without making the drive yourself.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Kenosha%20Wisconsin%20Lake%20Michigan%20harborfront%20with%20historic%20lighthouse%20and%20marina%20at%20golden%20hour%2C%20downtown%20Kenosha%20with%20vintage%20streetcar%20and%20electric%20streetcar%20line%2C%20waterfront%20parks%20and%20piers%20along%20the%20lake%2C%20warm%20amber%20and%20golden%20light%20reflecting%20on%20calm%20water%2C%20professional%20coastal%20city%20photography%2C%20wide%20angle%20composition%20with%20harbor%20and%20lighthouse%20in%20foreground%2C%20mixed%20historic%20and%20modern%20architecture%2C%20no%20text%20or%20people%20visible&width=1800&height=700&seq=kenosha-wi-hero-001&orientation=landscape",
  heroImageAlt: "Kenosha Wisconsin Lake Michigan harborfront and lighthouse at golden hour",
  geoPosition: "42.5847;-87.8212",
  geoPlacename: "Kenosha, Wisconsin",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 2500, Chicago, IL 60604",
    distance: "Approximately 60 miles from Kenosha — just over 1 hour via I-94 south",
  },
  nearbyCitiesZips: [
    { name: "Downtown Kenosha", zips: "53140, 53142, 53143" },
    { name: "Pleasant Prairie", zips: "53158" },
    { name: "Somers", zips: "53171" },
    { name: "Bristol", zips: "53104" },
    { name: "Salem Lakes", zips: "53168, 53179" },
    { name: "Twin Lakes", zips: "53181" },
    { name: "Paddock Lake", zips: "53168" },
    { name: "Silver Lake", zips: "53170" },
    { name: "Racine", zips: "53401, 53402" },
    { name: "Sturtevant", zips: "53177" },
    { name: "Zion, IL", zips: "60099" },
    { name: "Winthrop Harbor, IL", zips: "60096" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Closest WI city to Chicago Passport Agency — just 60 miles via I-94" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Kenosha County" },
    { icon: "ri-map-pin-2-line", title: "WI-IL Border Corridor", desc: "Serving Kenosha, Pleasant Prairie, Somers, and the Wisconsin-Illinois state line" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in the Kenosha area" },
  ],
  internalLinks: [
    { name: "Expedited passport in Racine, WI", route: "/cities/racine" },
    { name: "Emergency passport help in Milwaukee, WI", route: "/cities/milwaukee" },
    { name: "Urgent passport services in Appleton, WI", route: "/cities/appleton" },
    { name: "Wisconsin passport services overview", route: "/states/wisconsin" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 2500, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Kenosha, Wisconsin via secure registered courier to the Chicago Passport Agency (230 S Dearborn St, Chicago). Just 60 miles — about an hour via I-94. Kenosha is one of the best-positioned Wisconsin cities for expedited passport service thanks to its location at the Wisconsin-Illinois border, right on the I-94 corridor. We handle the Chicago drive so Kenosha County residents never need to navigate downtown traffic.",
  fpcOfficeDistance: "Serving Kenosha, Pleasant Prairie, Somers, Bristol, Salem Lakes, Twin Lakes, Paddock Lake, Silver Lake, and all Kenosha County communities along the Wisconsin-Illinois border corridor",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kenosha and Kenosha County. From the historic downtown harbor district and lakefront to Pleasant Prairie, Somers, and the Wisconsin-Illinois border communities — we serve all of southeastern Wisconsin's border corridor with direct courier access to the Chicago Passport Agency just 60 miles away.",
  nearbyCitiesIntro: "We serve Kenosha and all nearby communities including Pleasant Prairie, Somers, Bristol, Salem Lakes, Twin Lakes, Paddock Lake, and Silver Lake. We also serve cross-border travelers in northern Lake County, Illinois. Kenosha's border location makes it a natural hub for expedited passport services serving both Wisconsin and Illinois residents near the state line.",
  howItWorksIntro: "Most Kenosha travelers — especially border corridor professionals commuting to Chicago and Lake County families — complete everything online and ship documents via overnight courier from any UPS or FedEx in the Kenosha area. At just 60 miles from Chicago, our couriers can achieve some of the fastest turnaround times in Wisconsin.",
  mistakesIntro: "Living just 60 miles from the Chicago Passport Agency creates a dangerous illusion for Kenosha residents — 'I'll just drive down.' But the agency requires appointments and turns away walk-ins. Here are the most common mistakes we see from Kenosha County travelers.",
  testimonialsIntro: "Kenosha travelers — from border corridor professionals to Pleasant Prairie families to Carthage College students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Kenosha, WI? Here are the most common ones we hear from Kenosha County and border corridor travelers.",
  statePageRoute: "/states/wisconsin",
  statePageName: "Wisconsin",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (WI DHS)", url: "https://www.dhs.wisconsin.gov/vitalrecords/", desc: "Wisconsin Department of Health Services — Vital Records Office for birth and death certificates statewide" },
    { label: "Marriage Licenses (Kenosha County Clerk)", url: "https://www.kenoshacounty.org/", desc: "Kenosha County Clerk — marriage license applications and certified copies for Kenosha and Kenosha County" },
    { label: "Divorce Decrees (Kenosha County Circuit Court)", url: "https://www.wicourts.gov/courts/circuit/kenosha.htm", desc: "Kenosha County Circuit Court — divorce decree records for Kenosha and Kenosha County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Wisconsin birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  dmvWebsite: "https://www.dot.wisconsin.gov/drivers",
  dmvLabel: "Wisconsin DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Just 60 miles to Chicago (1-hour drive)", "Still requires pre-scheduled appointment — can't just show up"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Closest WI city to Chicago Agency — fastest WI processing", "No drive or appointment needed", "Ideal for Kenosha and border corridor travelers", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service USPS", "Good for planned travel from MKE or ORD", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Kenosha is only 60 miles from the Chicago Passport Agency — our couriers make same-day delivery possible, as fast as 24 hours. The fastest turnaround in Wisconsin.",
      bullets: ["Closest WI city to Chicago Agency — just 60 miles", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in WI",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Kenosha adults with a passport issued within the last 15 years. Ideal for border corridor commuters and Kenosha County professionals.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Kenosha and Pleasant Prairie"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Kenosha residents, border corridor families, and Carthage College students heading abroad.",
      bullets: ["Acceptance facility scheduling near Kenosha", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Kenosha residents — whether lost at home, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Chicago Agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Kenosha and border corridor families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Kenosha County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kenosha WI", description: "Urgent passport processing for Kenosha Wisconsin travelers via Chicago Passport Agency courier — just 60 miles from Kenosha." },
    { name: "Expedited Passport Renewal Kenosha WI", description: "Fast passport renewal for Kenosha and Kenosha County Wisconsin residents." },
    { name: "First-Time Passport Kenosha WI", description: "New passport application services for Kenosha Wisconsin residents and border corridor families." },
    { name: "Child Passport Kenosha WI", description: "Minor passport services for Kenosha Wisconsin families with children under 16." },
  ],
  testimonials: [
    {
      name: "Patricia G.",
      location: "Pleasant Prairie, WI",
      rating: 5,
      text: "Flight to Cancun in 3 days, realized my passport was expired. Fast Passport Center couriered to Chicago — just 60 miles away — and I had my renewed passport in 28 hours. Living so close to the border makes it incredibly fast.",
      service: "Emergency Passport",
    },
    {
      name: "Michael D.",
      location: "Downtown Kenosha",
      rating: 5,
      text: "Business trip to London with 5 days notice. I commute to Chicago every day but didn't want to deal with the passport agency appointment system. Fast Passport Center handled everything — new passport in 48 hours. Easier than driving myself.",
      service: "Expedited Renewal",
    },
    {
      name: "Lisa W.",
      location: "Somers, WI",
      rating: 5,
      text: "Spring break trip to Dominican Republic with the family. Three kids needed first-time passports. Fast Passport Center walked us through everything and all four passports arrived in 4 days. Perfect for Kenosha County families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Robert J.",
      location: "Salem Lakes, WI",
      rating: 5,
      text: "Lost my passport during a weekend trip to Chicago. Had a flight to Paris in 6 days. Fast Passport Center replaced it in 48 hours. The Kenosha border location makes overnight shipping incredibly fast.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "kenosha-1",
      name: "Kenosha Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4111 7th Ave",
      city: "Kenosha",
      state: "WI",
      zip: "53140",
      phone: "(262) 657-6090",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "Downtown Kenosha",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Kenosha. Appointment required. Convenient downtown location near the harbor district.",
      icon: "ri-mail-line",
    },
    {
      id: "kenosha-2",
      name: "Kenosha County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1010 56th St",
      city: "Kenosha",
      state: "WI",
      zip: "53140",
      phone: "(262) 653-3315",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Kenosha, county administration building",
      website: "https://www.kenoshacounty.org/",
      websiteLabel: "Kenosha County Clerk",
      notes: "Accepts passport applications for Kenosha County residents. No photo services on-site — bring photos.",
      icon: "ri-government-line",
    },
    {
      id: "kenosha-3",
      name: "Pleasant Prairie Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8201 104th Ave",
      city: "Pleasant Prairie",
      state: "WI",
      zip: "53158",
      phone: "(262) 947-0230",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 5 miles southwest of downtown Kenosha",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Pleasant Prairie and Premium Outlets area. Good alternative when Kenosha facilities are busy.",
      icon: "ri-mail-line",
    },
    {
      id: "kenosha-4",
      name: "Racine Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "700 Lake Ave",
      city: "Racine",
      state: "WI",
      zip: "53403",
      phone: "(262) 632-5600",
      hours: "Mon–Fri: 8:30 AM – 5:30 PM",
      distance: "Approximately 15 miles north of downtown Kenosha",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative facility north of Kenosha. Good option for northern Kenosha County and Racine residents.",
      icon: "ri-mail-line",
    },
    {
      id: "kenosha-5",
      name: "Bristol Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8020 199th Ave",
      city: "Bristol",
      state: "WI",
      zip: "53104",
      phone: "(262) 857-2215",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Approximately 10 miles west of downtown Kenosha",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western Kenosha County facility. Convenient for Bristol and Salem Lakes residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Chicago Agency", agency: "60 miles — 1-hr drive, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Border Region Advantage", agency: "None — same rules for everyone", fpc: "Maximizes Kenosha's proximity to Chicago for fastest WI turnaround" },
  ],
  mistakes: [
    {
      icon: "ri-map-pin-line",
      title: "Trying to Walk Into Chicago Passport Agency",
      description: "Even though Kenosha is only 60 miles from Chicago, the agency requires appointments — walk-ins are turned away. Our courier service pre-secures submission slots so your documents are accepted without you needing to be there.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating Chicago Traffic",
      description: "A 60-mile drive from Kenosha to downtown Chicago can easily become 2+ hours during rush hour, Bears games, or summer festivals. The Edens Expressway and Kennedy are notorious for unpredictable delays. Our courier service eliminates this stress entirely.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Retail photo services in the Kenosha area sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background — no glasses, no smiling with teeth showing.",
    },
    {
      icon: "ri-file-list-line",
      title: "Using the Wrong Form (DS-82 vs DS-11)",
      description: "Border corridor residents often grab the wrong form. DS-82 is only for adult renewals where you have your current passport. Everything else requires DS-11 and an in-person acceptance facility visit.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Kenosha travelers heading to Europe or Asia frequently discover this requirement too late — especially those with frequent travel schedules.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Until Summer Rush",
      description: "Kenosha County sees heavy passport demand May–July as families prepare for summer vacations. Kenosha-area acceptance facilities fill 3–4 weeks in advance during this period. Start early.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Kenosha or Kenosha County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS or FedEx in the Kenosha area." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document, then couriers to Chicago — just 60 miles away." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Chicago Passport Agency via our pre-secured courier submission slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kenosha address — fully trackable." },
  ],
  faqs: [
    { q: "How close is Kenosha to a passport agency?", a: "Kenosha is one of the closest Wisconsin cities to a regional passport agency. The Chicago Passport Agency is approximately 60 miles south of Kenosha — about a 1-hour drive via I-94. However, the agency requires pre-scheduled appointments and turns away walk-ins. Fast Passport Center's couriers handle the delivery so you don't need to make the trip or secure an appointment." },
    { q: "Can I just drive to the Chicago Passport Agency from Kenosha?", a: "Technically yes, but the Chicago Passport Agency only accepts visitors with pre-scheduled appointments. Walk-ins are turned away regardless of how close you live. Fast Passport Center pre-secures courier submission slots, ensuring your documents are accepted on your behalf without you needing to be there." },
    { q: "How fast can I get an emergency passport in Kenosha?", a: "Because Kenosha is only 60 miles from Chicago, Fast Passport Center can achieve some of the fastest turnaround times in Wisconsin — typically 24–48 hours for emergency cases. The proximity to Chicago makes overnight courier delivery extremely efficient." },
    { q: "Does Kenosha have its own passport agency?", a: "No. Wisconsin has no regional passport agency. The nearest is the Chicago Passport Agency, just 60 miles south. Kenosha's position at the Wisconsin-Illinois border with direct I-94 access makes it one of the best-positioned Wisconsin cities for fast passport processing." },
    { q: "What airports do Kenosha travelers use for international flights?", a: "Kenosha travelers typically use Chicago O'Hare (ORD, 50 miles south) or Milwaukee Mitchell (MKE, 40 miles north) for international flights. Both airports offer extensive international routes. Midway Airport (MDW, 65 miles south) is another option for some charter flights." },
    { q: "Where can I get passport photos in Kenosha?", a: "Walgreens (multiple locations including 5200 75th St), CVS (7221 120th Ave in Pleasant Prairie), and FedEx Office all offer passport photos in the Kenosha area. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Pleasant Prairie and Somers residents?", a: "Yes. Fast Passport Center serves all of Kenosha County including Kenosha, Pleasant Prairie, Somers, Bristol, Salem Lakes, Twin Lakes, Paddock Lake, and Silver Lake. Our courier service works the same for everyone throughout the region." },
    { q: "Can I take the Metra train to the Chicago Passport Agency from Kenosha?", a: "Yes, the Union Pacific North Metra line runs from Kenosha to Chicago's Ogilvie Transportation Center, which is about a 15-minute walk from the Chicago Passport Agency. However, you still need a pre-scheduled appointment. Fast Passport Center's courier service handles the delivery so you don't need to make the trip at all." },
  ],
  photoLocations: [
    { name: "Walgreens — Kenosha (75th St)", address: "5200 75th St, Kenosha, WI 53142", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Pleasant Prairie", address: "7221 120th Ave, Kenosha, WI 53142", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Walgreens — Kenosha (Sheridan)", address: "3701 Sheridan Rd, Kenosha, WI 53140", hours: "Mon–Sun: 7AM–10PM" },
    { name: "FedEx Office — Kenosha", address: "6940 75th St, Kenosha, WI 53142", hours: "Mon–Fri: 7AM–8PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "WI DMV — Kenosha", address: "8600 Sheridan Rd, Kenosha, WI 53143", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Full-service DMV for Kenosha County residents. REAL ID and driver's license renewals. Appointment recommended.", featured: true },
    { name: "WI DMV — Racine", address: "2229 S Green Bay Rd, Racine, WI 53406", hours: "Mon–Fri: 8:30AM–4:30PM", note: "Alternative for northern Kenosha County residents. About 15 miles north.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "50 miles south of downtown Kenosha — approximately 50 minutes via I-94",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Kenosha travelers. One of the world's busiest airports with direct flights to destinations across six continents. Major United and American Airlines hub.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "O'Hare Airport",
      featured: true,
    },
    {
      code: "MKE",
      name: "Milwaukee Mitchell International Airport",
      distance: "40 miles north of downtown Kenosha — approximately 40 minutes via I-94",
      address: "5300 S Howell Ave, Milwaukee, WI 53207",
      note: "Alternative airport for Kenosha travelers. Seasonal international routes plus extensive domestic connections. Often less crowded than O'Hare.",
      flightUrl: "https://www.mitchellairport.com/",
      flightLabel: "MKE Airport",
      featured: false,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "65 miles south of downtown Kenosha — approximately 1 hour via I-94",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Major Southwest Airlines hub with extensive domestic and Caribbean/Mexico routes. Good option for Kenosha travelers flying Southwest.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "Midway Airport",
      featured: false,
    },
  ],
};